<template>
  <v-flex xl4 md5 sm10 xs11 class="grow" v-if="!passwordPolicy.disablePasswordPolicy">                
    <v-container style="position: relative;top: 13%;" class="flex text-xs-center grey lighten-4">  
      <v-card flat class="py-2">
        <v-card-title primary-title>
          <h4>{{ $t("ChangePassword.Policy") }}</h4> 
        </v-card-title>            
        <ul class="text-xs-left" style="list-style:none">
          <li class="flex items-center gap-2" v-if="passwordPolicy.minLength > 0" :class="{'error--text':rulePasswordMinLength(newPassword) !== true}">
            <v-icon v-if="rulePasswordMinLength(newPassword) == true"  class="success--text">mdi-check-circle-outline</v-icon> 
            <v-icon v-else class="error--text">mdi-alert-circle-outline</v-icon> 
            {{ $tc("ChangePassword.PolicyLength",passwordPolicy.minLength) }}
          </li>
          <li class="flex items-center gap-2" v-if="passwordPolicy.nbMinNumberChar > 0" :class="{'error--text':rulePasswordMinNumber(newPassword) !== true }">
            <v-icon v-if="rulePasswordMinNumber(newPassword) == true"  class="success--text">mdi-check-circle-outline</v-icon> 
            <v-icon v-else class="error--text">mdi-alert-circle-outline</v-icon> 
            {{ $tc("ChangePassword.PolicyNumber",passwordPolicy.nbMinNumberChar) }}
          </li>
          <li class="flex items-center gap-2" v-if="passwordPolicy.nbMinSpecialChar > 0" :class="{'error--text':rulePasswordSpecialChar(newPassword) !== true }">
            <v-icon v-if="rulePasswordSpecialChar(newPassword) == true"  class="success--text">mdi-check-circle-outline</v-icon> 
            <v-icon v-else class="error--text">mdi-alert-circle-outline</v-icon> 
            {{ $tc("ChangePassword.PolicySpecial",passwordPolicy.nbMinSpecialChar) }}
          </li>
          <li class="flex items-center gap-2" v-if="passwordPolicy.nbMinUpperChar > 0" :class="{'error--text':ruleUpperChar(newPassword) !== true }">
            <v-icon v-if="ruleUpperChar(newPassword) == true"  class="success--text">mdi-check-circle-outline</v-icon> 
            <v-icon v-else class="error--text">mdi-alert-circle-outline</v-icon> 
            {{ $tc("ChangePassword.PolicyUpperCase",passwordPolicy.nbMinUpperChar) }}
          </li>
          <li class="flex items-center gap-2" v-if="passwordPolicy.nbMinLowerChar > 0" :class="{'error--text':ruleLowerChar(newPassword) !== true }">
            <v-icon v-if="ruleLowerChar(newPassword) == true"  class="success--text">mdi-check-circle-outline</v-icon> 
            <v-icon v-else class="error--text">mdi-alert-circle-outline</v-icon> 
            {{ $tc("ChangePassword.PolicyLowerCase",passwordPolicy.nbMinLowerChar) }}
          </li>
        </ul>  
        <p class="text-xs-left ma-2" v-if="passwordPolicy.nbHistoryRetention > -1">
          {{ $tc("ChangePassword.PolicyHistory",passwordPolicy.nbHistoryRetention) }}          
        </p>          
        <p class="text-xs-left ma-2"  v-if="passwordPolicy.validityPeriod > 0">
          {{ $tc("ChangePassword.PolicyPeriod",passwordPolicy.validityPeriod) }}
        </p>   
        <template v-if="connectedUser && connectedUser.passExpiresInDays != null">
          <hr class="mx-2"/>
          <p  class="ma-2">
            <strong>{{  $tc("ChangePassword.Expiration",connectedUser.passExpiresInDays) }}</strong>
            <v-btn to="/"  color="primary" large block >{{ $t("ChangePassword.Later") }}</v-btn>
          </p>    
      </template>
      </v-card>
    </v-container>
  </v-flex>
</template>

<script lang="ts">

import { Component, Vue, Watch } from 'vue-property-decorator';
import * as rules from '@/utils/validationRules'
import { PasswordPolicy } from '@/models/datapool/PasswordPolicy';
import { DataPoolGlobalKeys } from '@/enum/DataPool';

@Component({
  name: 'PasswordPolicyCheck', 
  props:{
    newPassword:{
          type: String,
          required: true
      }
  }
})
export default class PasswordPolicyCheck extends Vue {  
  time = new Date()  
  timerID = -1
  newPassword!:string

  get passwordPolicy(){
    return PasswordPolicy.createPasswordPolicy(this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.passwordPolicy']))
  }

  rulePasswordMinLength(v:string) {
    return this.passwordPolicy.disablePasswordPolicy || rules.rulePasswordMinLength(v,this.passwordPolicy.minLength)
  }

  rulePasswordMinNumber(v:string) {
    return this.passwordPolicy.disablePasswordPolicy || (v.match(/\d/g)?.length ?? 0) >= this.passwordPolicy.nbMinNumberChar
  }

  rulePasswordSpecialChar(v:string) {    
    return this.passwordPolicy.disablePasswordPolicy || (v.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g)?.length ?? 0) >= this.passwordPolicy.nbMinSpecialChar
  }  

  ruleUpperChar(v:string) {    
    return this.passwordPolicy.disablePasswordPolicy || (v.match(/[A-Z]/g)?.length ?? 0) >= this.passwordPolicy.nbMinUpperChar
  }  

  ruleLowerChar(v:string) {    
    return this.passwordPolicy.disablePasswordPolicy || (v.match(/[a-z]/g)?.length ?? 0) >= this.passwordPolicy.nbMinUpperChar
  }  

  get connectedUser(){
    return this.$store.myGetters?.userProfile
  }

  get isValid(){
    return this.rulePasswordMinLength(this.newPassword) 
        && this.rulePasswordMinNumber(this.newPassword) 
        && this.rulePasswordSpecialChar(this.newPassword) 
        && this.ruleUpperChar(this.newPassword) 
        && this.ruleLowerChar(this.newPassword)
  }
}
</script>
